import { render, staticRenderFns } from "./PhoneTable.vue?vue&type=template&id=8326dd84&scoped=true"
import script from "./PhoneTable.vue?vue&type=script&lang=js"
export * from "./PhoneTable.vue?vue&type=script&lang=js"
import style0 from "./PhoneTable.vue?vue&type=style&index=0&id=8326dd84&prod&scoped=true&lang=scss"
import style1 from "./PhoneTable.vue?vue&type=style&index=1&id=8326dd84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8326dd84",
  null
  
)

export default component.exports